const topics = [
  { label: '韩漫推荐', icon: 'ri-heart-3-line', count: '2.3万+', hot: true },
  { label: '日漫经典', icon: 'ri-sun-line', count: '4.1万+', hot: true },
  { label: '国漫崛起', icon: 'ri-china-railway-line', count: '1.8万+', hot: true },
  { label: '全本完结', icon: 'ri-checkbox-circle-line', count: '5.6万+', hot: false },
  { label: '恋爱甜宠', icon: 'ri-hearts-line', count: '3.2万+', hot: true },
  { label: '热血冒险', icon: 'ri-fire-line', count: '2.9万+', hot: false },
  { label: '悬疑推理', icon: 'ri-search-eye-line', count: '1.5万+', hot: false },
  { label: '奇幻玄幻', icon: 'ri-meteor-line', count: '2.7万+', hot: false },
  { label: '都市情感', icon: 'ri-building-line', count: '1.9万+', hot: true },
  { label: '搞笑日常', icon: 'ri-emotion-laugh-line', count: '3.5万+', hot: false },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1400px] mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-3xl font-extrabold text-foreground-950 mb-3">
              热门话题标签
            </h2>
            <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
              探索当下最受读者欢迎的漫画类型与话题，发现你的下一部心头好
            </p>
          </div>

          <div className="flex flex-wrap justify-center gap-3 md:gap-4">
            {topics.map((topic, i) => (
              <a
                key={i}
                href="#index"
                className="group inline-flex items-center gap-2.5 px-4 py-3 bg-background-50 border border-background-200/70 rounded-full hover:border-primary-400 hover:bg-primary-50/50 transition-all cursor-pointer"
              >
                <div className="w-7 h-7 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
                  <i className={`${topic.icon} text-xs`}></i>
                </div>
                <span className="text-sm font-medium text-foreground-800 whitespace-nowrap">{topic.label}</span>
                <span className="text-xs text-foreground-400 whitespace-nowrap">{topic.count}</span>
                {topic.hot && (
                  <span className="inline-flex items-center gap-0.5 text-[10px] font-semibold text-accent-600 bg-accent-100 px-1.5 py-0.5 rounded-full">
                    <i className="ri-fire-line text-[8px]"></i>热
                  </span>
                )}
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}